import type { Language } from "@/entities/language";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential, REFERENTIAL_ENDPOINT } from "@/entities/referential";

export const useReferentialLanguages = (
  options?: UseReferentialOptions<Language[]>
) => {
  const { data, ...result } = useReferential<Language[]>(
    REFERENTIAL_ENDPOINT.LANGUAGES,
    options
  );

  return {
    languages: data ?? [],
    defaultLanguage: data?.find((lang) => lang.is_default),
    ...result,
  };
};
